module.exports = __webpack_public_path__ + "img/spacehelmet.4a19e75e.png";